import React from 'react';

import { type PermissionKey, useCan } from '../../permissions';
import PagesError401 from '../ErrorPages/PagesError401';

type PermissionGuardProps = {
    permission?: PermissionKey;
    permissionAny?: PermissionKey[];
    Component: React.ComponentType;
};
export const PermissionGuard = ({ permission, permissionAny, Component }: PermissionGuardProps) => {
    const can = useCan();
    if (!permission && !permissionAny?.length) return <Component />;
    const allowed = permissionAny?.length ? can.any(permissionAny) : can(permission as PermissionKey);
    return allowed ? <Component /> : <PagesError401 />;
};
